import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { FormalitesProvider } from './contexts/FormalitesContext';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// Client ID Google OAuth
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'VOTRE_GOOGLE_CLIENT_ID.apps.googleusercontent.com';

if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {
  console.warn('⚠️ REACT_APP_GOOGLE_CLIENT_ID non défini dans .env');
  console.warn('Créez un fichier .env avec: REACT_APP_GOOGLE_CLIENT_ID=votre_client_id');
  console.warn('Pour la production, ajoutez https://huma-forma.webapic.com dans Google Cloud Console');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <AuthProvider>
          <FormalitesProvider>
            <App />
          </FormalitesProvider>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
